<div class="task-complete-container flex flex-column">
	<div mat-dialog-title class="header">
		<app-icon class="warning-icon" name="warning" [lineWidth]="'1px'" [size]="'24'" [color]="'white'"></app-icon>
		WARNING
	</div>
	<mat-dialog-content class="flex flex-column flex-1 xs-title">
		<div class="confirmation-message">
			Marking this upload as Completed will ignore all errors and set the Payment Orders milestone to Completed.
		</div>
		<div>Do you want to continue?</div>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button class="mat-stroked-button cancel-btn" (click)="close(false)">CANCEL</button>
		<button class="mat-stroked-button submit-btn" (click)="close(true)">YES, CONTINUE</button>
	</mat-dialog-actions>
</div>
